import palette from '../../../themev5/palette';

const styles = {
  // ── LabelSeparationDialogHeader ──────────────────────────────────────────
  dialogTitle: {
    m: 0,
    p: 2
  },
  dialogTitleText: {
    color: palette.green.accept,
    fontWeight: 'bold',
    fontSize: '28px'
  },
  dialogCloseButton: {
    position: 'absolute',
    right: 5,
    top: 2,
    color: 'gray.light'
  },

  // ── Dialog layout (BrazilLabelSeparationDialog / BrazilSectionMappingDialog) ──
  loadingBox: {
    px: 2,
    pb: 2
  },
  dialogContent: {
    pt: 0,
    pb: 2,
    overflow: 'hidden'
  },
  gridContainer: {
    height: 600
  },
  pdfColumn: {
    height: { xs: 400, lg: 600 },
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    pr: 0.5
  },
  formColumn: {
    height: { xs: 400, lg: 600 },
    overflowY: 'auto',
    pl: 0.5
  },

  // ── SignedPdfViewerPane ───────────────────────────────────────────────────
  /** Spread with `height` prop: sx={{ ...styles.pdfLoadingBox, height }} */
  pdfLoadingBox: {
    width: '100%',
    pb: 2
  },
  /** Spread with `height` prop: sx={{ ...styles.pdfViewerBox, height }} */
  pdfViewerBox: {
    width: '100%',
    minHeight: 0,
    overflow: 'hidden'
  },
  /** Spread with `height` prop: sx={{ ...styles.pdfEmptyBox, height }} */
  pdfEmptyBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  pdfEmptyText: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: palette.primary.main
  },

  // ── LabelRangeForm ────────────────────────────────────────────────────────
  rangeForm: {
    pr: 1,
    pb: 1
  },
  formActions: {
    mt: 2
  },
  actionButton: {
    textTransform: 'none'
  },

  // ── LabelRangeRow ─────────────────────────────────────────────────────────
  rangeRowCard: {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    p: 2,
    mb: 2
  },
  rangeRowHeader: {
    mb: 1.5
  },
  rangeRowLabel: {
    fontWeight: 'bold',
    color: palette.green.accept
  }
};

export default styles;
